export default {
  'DONATION_PERIOD': '定期定額',
  'DONATION_SINGLE': '單次捐款',
};
